import { Dashboard, DashboardFooter, Folder, Inquery1, Inquery2, Inquery3, Inquery4, 
  Inquery5, NotificationFooter, OfferInsurance , ProfileFooter,  Peyment,StatusUp,Wallet,Note,Loan,Send,
  People} from "../assets";
import routes from "./routes";
import { DateObject } from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian"
export function toFarsiNumber(n:any) {
    if (n) {
      const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return n.toString().replace(/\d/g, (x :any) => farsiDigits[x]);
    } else return "";
  }
  /* eslint-disable */
export function getPersianDate () { 
    let options :any = {  month: 'long', day: 'numeric',  weekday: 'long'};
let today = new Date().toLocaleDateString('fa-IR', options);
return today;
  }

export function getPersianYear() {
    let options: any = { year: 'numeric' };
    let year = new Date().toLocaleDateString('fa-IR', options);
    return year;
}

  export const menuItems = [
    {name: 'نمایه' ,  path :`${routes.DASHBOARD}`, type:'shallow' , icon:<Dashboard/> },
    {name: "  استعلام و خرید بیمه  " ,  path :`${routes.INSURANCERATE}`, type:'shallow' , icon:<StatusUp />  },
    {name: "پیشنهادهای ثبت شده  ", path :`${routes.OFFERSLIST}`, type:'shallow' , icon:<OfferInsurance /> },
    {name: "بیمه  نامه ها " ,  path :`${routes.INSURANCEPOLICY}`, type:'shallow' , icon:<Folder/> },

    {name: "پرداختی ها  ", path :`${routes.TRANSACTIONS}`, type:'shallow' , icon:<Peyment/> },
    {name: "ثبت خسارت", type:'shallow' , icon:<Note color="#bcbcbc"/> ,disable:true  },
    {name: "درخواست تسهیلات", type:'shallow' , icon:<Loan color="#bcbcbc"/> ,disable:true },
    {name: "برداشت از اندوخته", type:'shallow' , icon:<Send color="#bcbcbc"/> ,disable:true },
    {name: "دعوت از دوستان", type:'shallow' , icon:<People color="#bcbcbc"/> ,disable:true },



    

]

export const footerItems = [
  {name: "نمایه" , path :`${routes.DASHBOARD}`, type:'shallow' , icon:<DashboardFooter /> ,activeIcon:<DashboardFooter  color="#00AA5B"/> },
  // {name: "حساب کاربری" ,  path :`${routes.PROFILE}`, type:'shallow' , icon:<ProfileFooter /> ,activeIcon:<ProfileFooter  color="#00AA5B"/> },
  {name: "   استعلام و خرید بیمه  " ,  path :`${routes.INSURANCERATE}`, type:'shallow' , icon:<StatusUp /> ,activeIcon:<StatusUp  color="#00AA5B"/> , displayInModal:true   },
  {name: "پیشنهادهای ثبت شده  ", path :`${routes.OFFERSLIST}`, type:'shallow' , icon:<OfferInsurance /> , activeIcon:<OfferInsurance  color="#00AA5B"/> , displayInModal:true },
  {name: "بیمه  نامه ها " ,  path :`${routes.INSURANCEPOLICY}`, type:'shallow' , icon:<Folder /> ,activeIcon:<Folder  color="#00AA5B"/> },
  {name: "پرداختی ها  ", path :`${routes.PREPAYMENT}`, type:'shallow' , icon:<Peyment />,activeIcon:<DashboardFooter  color="#00AA5B"/>, displayInModal:true },
  {name: "ثبت خسارت",path :`${routes.PREVIEW}`, type:'shallow' ,icon:<Note color="#bcbcbc"/>  ,disable:true , displayInModal:true  },
  {name: "درخواست تسهیلات",path :`${routes.PREVIEW}`, type:'shallow' ,  icon:<Loan color="#bcbcbc"/>  ,disable:true , displayInModal:true  },
  {name: "برداشت از اندوخته",path :`${routes.PREVIEW}`, type:'shallow' , icon:<Wallet color="#bcbcbc"/>  ,disable:true , displayInModal:true  },
  {name: "دعوت از دوستان",path :`${routes.PREVIEW}`, type:'shallow' , icon:<People color="#bcbcbc"/>  ,disable:true , displayInModal:true  },
  {name: "اعلانات", path: `${process.env.REACT_APP_CRM_URL}`, type: 'shallow', icon: <NotificationFooter />},

]


var persianNumber = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  var arabicNumber = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
  export function fixNumbers(str:any) {
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumber[i], i).replace(arabicNumber[i], i);
      }
    }
    return str;
  }

  export function numberWithCommas(x:any) {
    x = x?.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
    return x;
  }




  export function productIcon(name:any) {
    switch (name) {
      case "Universal" : 
      return Inquery1;
      case "UniversalUnitlink" : 
      return Inquery2;
      case "UniversalHousing" : 
      return Inquery3;
      
      case "mostamari" : 
      return Inquery4;
      

    default:
      return Inquery5;
  }
  }


  export const insuranceTypeList = [
    {title:"زندگی و سرمایه گذاری",value:"Universal" , url:"https://hummersinsurance.com/products/zendegi-sarmaye-gozari"},
    {title:" زندگی متصل به صندوق های بازار سرمایه",value:"UniversalUnitlink" , url:"https://hummersinsurance.com/products/zendegi-motasel-be-sandogh"},
    {title:" زندگی و مسکن (مسکن متری) ",value:"UniversalHousing" , url:"https://hummersinsurance.com/products/maskan-metri"},
    {title:"عمر و حوادث گروهی",value:"group_life" , url:"https://hummersinsurance.com/"},
    {title:"عمر زمانی",value:"term_life" , url:"https://hummersinsurance.com/"},
    {title:"عمر مانده بدهکار",value:"mort_life" , url:"https://hummersinsurance.com/"},
    {title:"تمام عمر",value:"whole_life" , url:"https://hummersinsurance.com/"},


  ]
  
  export function policyIcon(name:any) {
    switch (name) {
      case "universal" : 
      return Inquery1;
      case "UniversalFound" : 
      return Inquery2;
      case "UniversalHousing" : 
      return Inquery3;
    default:
      return Inquery1;
  }
  }

  export const InvestmentPercentage = (item:any) => {
    return ((item?.units_all - item?.remain_units ) / item?.units_all ) * 100
}
export const planTypeList = [
  {title:"زندگی و سرمایه گذاری",value:"Universal" , link:"/inquery-update"},
  {title:" زندگی متصل به صندوق های بازار سرمایه",value:"UniversalUnitlink" , link:"/unitlink-update"},
  {title:" زندگی و مسکن (مسکن متری) ",value:"UniversalHousing" , link:"/universal-update"},
]

export const soldierStatus = [
 { value:"Not Done", title:"انجام ندادم"},
  {value:"Done", title:"انجام دادم"},
 { value:"Medical exemption", title:"معافیت پزشکی"},
  {value:"Non-medical exemption", title:"معافیت غیر پزشکی"},
  {value:"Serving", title:"در حال انجام"},
]

export function parsePersianDate(dateString: any) {
  if(dateString){
    const [year, month, day] = dateString?.split("/").map(Number);
    return new DateObject({
      calendar: persian,
      year: year,
      month: month,
      day: day
    });

  }
} 
export function showPercentTitle(percent: any): string {
  const percentNumber = Number(percent);

  if (percentNumber > 100) {
    switch (percentNumber) {
      case 101:
        return "به میزان طلب از بیمه‌نامه";
      case 102:
        return "سرمایه‌پس از کسر مبلغ بدهکاری";
      default:
        return "";
    }
  }

  return percent.toString();
}